export const ADMIN = 'admin'
export const SUPER = 'super'
export const GENERAL = 'general'
export const NO_ACCESS = 'no access'

export const INSIGHT_TYPE = '373fcf96-e67d-4ec1-bc1a-dd6a0d28db76'
export const DATASET_TYPE = 'b73b2d11-60b2-4ac7-934e-8f68093e7746'
export const DISCOVERY_TYPE = '733e8bdf-dccc-4033-87c3-285d28f54d0b'
export const WEBPAGE_TYPE = '73889ead-08eb-4e8d-8d2f-cb6547dba223'
